import Raven from 'raven-js';

export function CalloutService(toaster, GENERIC_ERROR_MESSAGE, GENERIC_ERROR) {
    'ngInject';
    var calloutTypes = {
        error: 'error',
        success: 'success',
        info: 'info'
    };
    var service = {
        error: generateError,
        success: generateSuccess,
        info: generateInfo
    };
    return service;

    ///---------------------------------------------

    function _displayGlobalCallout(type, message) {
        var globalCalloutOptions = {
            type: type,
            body: message,
            timeout: 5000,
            showCloseButton: false,
            positionClass: 'toast-top-center'
        };

        toaster.pop(globalCalloutOptions);
    }

    function generateError(errorMessage, error = GENERIC_ERROR) {
        if(!errorMessage) {
            errorMessage = GENERIC_ERROR_MESSAGE;
            Raven.captureMessage('Generic error captured', {
                level: 'error',
                extra: { error }
            });
        }

        _displayGlobalCallout(calloutTypes.error, errorMessage);

        return { errorMessage, error };
    }

    function generateInfo(infoMessage) {
        _displayGlobalCallout(calloutTypes.info, infoMessage);
        return { infoMessage };
    }

    function generateSuccess(successMessage) {
        _displayGlobalCallout(calloutTypes.success, successMessage);
        return { successMessage: successMessage };
    }
}
